import {
  ORG_REQUEST,
  ORG_SUCCESS,
  ORG_FAIL,
  ORG_CLEAR_ERRORS,
  ORG_SIMPLE_REQUEST,
  ORG_SIMPLE_SUCCESS,
  ORG_SIMPLE_FAIL,
  ORG_SIMPLE_CLEAR_ERRORS
} from "../Constants/org_hierarchy_constants";

export const org_data_reducer = (
  state = {
    org_data: [],
  },
  action
) => {
  switch (action.type) {
    case ORG_REQUEST:
      return {
        org_data_loading: true,
        org_data: [],
        org_data_status: "pending",
      };
    case ORG_SUCCESS:
      return {
        org_data_loading: false,
        org_data: action.payload.data,
        org_data_status: true,
      };
    case ORG_FAIL:
      return {
        org_data_loading: false,
        org_data: null,
        org_data_error: action.payload,
        org_data_status: false,
      };

    case ORG_CLEAR_ERRORS:
      return {
        ...state,
        org_data_error: null,
      };
    default:
      return state;
  }
};



export const org_simple_data_reducer = (
  state = {
    org_simple_data: [],
  },
  action
) => {
  switch (action.type) {
    case ORG_SIMPLE_REQUEST:
      return {
        org_simple_data_loading: true,
        org_simple_data: [],
        org_simple_data_status: "pending",
      };
    case ORG_SIMPLE_SUCCESS:
      return {
        org_simple_data_loading: false,
        org_simple_data: action.payload.data,
        org_simple_data_status: true,
      };
    case ORG_SIMPLE_FAIL:
      return {
        org_simple_data_loading: false,
        org_simple_data: null,
        org_simple_data_error: action.payload,
        org_simple_data_status: false,
      };

    case ORG_SIMPLE_CLEAR_ERRORS:
      return {
        ...state,
        org_simple_data_error: null,
      };
    default:
      return state;
  }
};
